import { Component } from '@angular/core';
import { DropdownDirective } from 'src/app/directives/dropdown.directive';
import { SharedModule } from 'src/app/modules/shared.module';
import { AuthService } from 'src/app/services/auth.service';
import { TermsAndConditionsService } from 'src/app/services/terms-and-conditions.service';
import packageJson from './../../../../package.json';

@Component({
  selector: 'app-header',
  imports: [SharedModule, DropdownDirective],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  public readonly version = packageJson.version;

  constructor(
    public readonly authService: AuthService,
    public readonly tecService: TermsAndConditionsService
  ) { }
}
